import BannerSegmentTwo from "Common/Components/EditableViews/BannerSegmentTwo";
import collapseIcon from "../../images/Collapse.svg"; 
import expandIcon from "../../assets/images/down-arrow.png"; 
import BlogSegment from "Common/Components/EditableViews/BlogSegment";
import BlogBannerSegment from "Common/Components/EditableViews/BlogBannerSegment";

const EditableView = ({
  segmentType,
  loader,
  setLoader,
  handleshowSagment,
  segment_id,
  data,
  pageId,
  collapse,
  index,
  handleDelete,
  pageType,
  isEditable,
  versionData = {
    is_edit: false,
  },
  toggleVisiblity = null,
}) => {
  switch (segmentType) {
    case "banner_segments":
      return (
        <div className="grid grid-cols-12 gap-x-5">
          <div className="col-span-12 card 2xl:col-span-12">
            <div
              onClick={handleshowSagment}
              className="flex items-center cursor-pointer "
            >
              <img  src={
        collapse.includes(index) ? expandIcon : collapseIcon
      }
      alt="toggle-icon"
      className="ml-2 w-6 h-6"
    />
              <p className="text-[20px] ml-4 mb-2 mt-2">Banner Segment</p>
            </div>
            {collapse.some((item) => item === index) && (
              <BlogBannerSegment
                pageType={pageType}
                loader={loader}
                setLoader={setLoader}
                pageId={pageId}
                data={data ? data : null}
                handleDelete={handleDelete}
                isEditable={isEditable}
                versionData={versionData ? versionData : null}
                segmentId={data?._id}
                segmentType={segmentType}
                toggleVisiblity={toggleVisiblity}
              />
            )}
          </div>
        </div>
      );
    case "blog_segments":
      return (
        <div className="grid grid-cols-12 gap-x-5">
          <div className="col-span-12 card 2xl:col-span-12">
            <div
              onClick={handleshowSagment}
              className="flex items-center cursor-pointer "
            >
              <img  src={
        collapse.includes(index) ? expandIcon : collapseIcon
      }
      alt="toggle-icon"
      className="ml-2 w-6 h-6"
    />
              <p className="text-[20px] ml-4 mb-2 mt-2">Blog Segment</p>
            </div>
            {collapse.some((item) => item === index) && (
              <BlogSegment
                loader={loader}
                setLoader={setLoader}
                pageId={pageId}
                data={data ? data : null}
                handleDelete={handleDelete}
                isEditable={isEditable}
                versionData={versionData ? versionData : null}
                segmentId={data?._id}
                segmentType={segmentType}
                toggleVisiblity={toggleVisiblity}
              />
            )}
          </div>
        </div>
      );
    default:
      return null;
  }
};

export default EditableView;
